// @ts-nocheck
/* eslint-disable */
export const arrowDownIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 5V17.0788L5.70775 11.2865L5 12L12 19L19 12L18.2923 11.2865L12.5 17.0788V5H11.5Z" fill="black"/></svg>`,
    name: 'arrow-down' as const
};